module.exports = __webpack_public_path__ + "7efa7b71c10c8b1fa749d411e45e0d33.svg";